module.exports = __webpack_public_path__ + "static/media/g3D.0905c1c0.png";